// @flow
import styled from "styled-components";

export const CancelRideWrapper = styled.div`
    color: white;
    margin-left: 5%;
    margin-right: 5%;
`;



// WEBPACK FOOTER //
// ./src/Components/TopBar/CancelRide/CancelRideStyle.js